import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["onScroll", "onScrollFrame", "onScrollStart", "onScrollStop", "onUpdate", "renderView", "renderTrackHorizontal", "renderTrackVertical", "renderThumbHorizontal", "renderThumbVertical", "tagName", "hideTracksWhenNotNeeded", "autoHide", "autoHideTimeout", "autoHideDuration", "thumbSize", "thumbMinSize", "universal", "autoHeight", "autoHeightMin", "autoHeightMax", "style", "children", "scrollbarId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _raf, { cancel as caf } from 'raf';
import css from 'dom-css';
import { Component, createElement, cloneElement } from 'react';
import PropTypes from 'prop-types';
import isString from '../../utils/isString';
import returnFalse from '../../utils/returnFalse';
import getInnerWidth from '../../utils/getInnerWidth';
import getInnerHeight from '../../utils/getInnerHeight';
import { containerStyleDefault, containerStyleAutoHeight, viewStyleDefault, viewStyleAutoHeight, viewStyleUniversalInitial, trackHorizontalStyleDefault, trackVerticalStyleDefault, thumbHorizontalStyleDefault, thumbVerticalStyleDefault, disableSelectStyle, disableSelectStyleReset } from './styles';
import { renderViewDefault, renderTrackHorizontalDefault, renderTrackVerticalDefault, renderThumbHorizontalDefault, renderThumbVerticalDefault } from './defaultRenderElements';

var Scrollbars = /*#__PURE__*/function (_Component) {
  _inherits(Scrollbars, _Component);

  var _super = _createSuper(Scrollbars);

  function Scrollbars(props) {
    var _this;

    _classCallCheck(this, Scrollbars);

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this, props].concat(rest));
    _this.getScrollLeft = _this.getScrollLeft.bind(_assertThisInitialized(_this));
    _this.getScrollTop = _this.getScrollTop.bind(_assertThisInitialized(_this));
    _this.getScrollWidth = _this.getScrollWidth.bind(_assertThisInitialized(_this));
    _this.getScrollHeight = _this.getScrollHeight.bind(_assertThisInitialized(_this));
    _this.getClientWidth = _this.getClientWidth.bind(_assertThisInitialized(_this));
    _this.getClientHeight = _this.getClientHeight.bind(_assertThisInitialized(_this));
    _this.getValues = _this.getValues.bind(_assertThisInitialized(_this));
    _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_assertThisInitialized(_this));
    _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_assertThisInitialized(_this));
    _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_assertThisInitialized(_this));
    _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_assertThisInitialized(_this));
    _this.scrollLeft = _this.scrollLeft.bind(_assertThisInitialized(_this));
    _this.scrollTop = _this.scrollTop.bind(_assertThisInitialized(_this));
    _this.scrollToLeft = _this.scrollToLeft.bind(_assertThisInitialized(_this));
    _this.scrollToTop = _this.scrollToTop.bind(_assertThisInitialized(_this));
    _this.scrollToRight = _this.scrollToRight.bind(_assertThisInitialized(_this));
    _this.scrollToBottom = _this.scrollToBottom.bind(_assertThisInitialized(_this));
    _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_assertThisInitialized(_this));
    _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_assertThisInitialized(_this));
    _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_assertThisInitialized(_this));
    _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_assertThisInitialized(_this));
    _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_assertThisInitialized(_this));
    _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_assertThisInitialized(_this));
    _this.handleWindowResize = _this.handleWindowResize.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.handleDrag = _this.handleDrag.bind(_assertThisInitialized(_this));
    _this.handleDragEnd = _this.handleDragEnd.bind(_assertThisInitialized(_this));
    _this.state = {
      didMountUniversal: false
    };
    return _this;
  }

  _createClass(Scrollbars, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addListeners();
      this.update();
      this.componentDidMountUniversal();
    }
  }, {
    key: "componentDidMountUniversal",
    value: function componentDidMountUniversal() {
      // eslint-disable-line react/sort-comp
      var universal = this.props.universal;
      if (!universal) return;
      this.setState({
        didMountUniversal: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
      caf(this.requestFrame);
      clearTimeout(this.hideTracksTimeout);
      clearInterval(this.detectScrollingInterval);
    }
  }, {
    key: "getScrollLeft",
    value: function getScrollLeft() {
      if (!this.view) return 0;
      return this.view.scrollLeft;
    }
  }, {
    key: "getScrollTop",
    value: function getScrollTop() {
      if (!this.view) return 0;
      return this.view.scrollTop;
    }
  }, {
    key: "getScrollWidth",
    value: function getScrollWidth() {
      if (!this.view) return 0;
      return this.view.scrollWidth;
    }
  }, {
    key: "getScrollHeight",
    value: function getScrollHeight() {
      if (!this.view) return 0;
      return this.view.scrollHeight;
    }
  }, {
    key: "getClientWidth",
    value: function getClientWidth() {
      if (!this.view) return 0;
      return this.view.clientWidth;
    }
  }, {
    key: "getClientHeight",
    value: function getClientHeight() {
      if (!this.view) return 0;
      return this.view.clientHeight;
    }
  }, {
    key: "getValues",
    value: function getValues() {
      var _ref = this.view || {},
          _ref$scrollLeft = _ref.scrollLeft,
          scrollLeft = _ref$scrollLeft === void 0 ? 0 : _ref$scrollLeft,
          _ref$scrollTop = _ref.scrollTop,
          scrollTop = _ref$scrollTop === void 0 ? 0 : _ref$scrollTop,
          _ref$scrollWidth = _ref.scrollWidth,
          scrollWidth = _ref$scrollWidth === void 0 ? 0 : _ref$scrollWidth,
          _ref$scrollHeight = _ref.scrollHeight,
          scrollHeight = _ref$scrollHeight === void 0 ? 0 : _ref$scrollHeight,
          _ref$clientWidth = _ref.clientWidth,
          clientWidth = _ref$clientWidth === void 0 ? 0 : _ref$clientWidth,
          _ref$clientHeight = _ref.clientHeight,
          clientHeight = _ref$clientHeight === void 0 ? 0 : _ref$clientHeight;

      return {
        left: scrollLeft / (scrollWidth - clientWidth) || 0,
        top: scrollTop / (scrollHeight - clientHeight) || 0,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth,
        scrollHeight: scrollHeight,
        clientWidth: clientWidth,
        clientHeight: clientHeight
      };
    }
  }, {
    key: "getThumbHorizontalWidth",
    value: function getThumbHorizontalWidth() {
      var _this$props = this.props,
          thumbSize = _this$props.thumbSize,
          thumbMinSize = _this$props.thumbMinSize;
      var _this$view = this.view,
          scrollWidth = _this$view.scrollWidth,
          clientWidth = _this$view.clientWidth;
      var trackWidth = getInnerWidth(this.trackHorizontal);
      var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
      if (trackWidth === width) return 0;
      if (thumbSize) return thumbSize;
      return Math.max(width, thumbMinSize);
    }
  }, {
    key: "getThumbVerticalHeight",
    value: function getThumbVerticalHeight() {
      var _this$props2 = this.props,
          thumbSize = _this$props2.thumbSize,
          thumbMinSize = _this$props2.thumbMinSize;
      var _this$view2 = this.view,
          scrollHeight = _this$view2.scrollHeight,
          clientHeight = _this$view2.clientHeight;
      var trackHeight = getInnerHeight(this.trackVertical);
      var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
      if (trackHeight === height) return 0;
      if (thumbSize) return thumbSize;
      return Math.max(height, thumbMinSize);
    }
  }, {
    key: "getScrollLeftForOffset",
    value: function getScrollLeftForOffset(offset) {
      var _this$view3 = this.view,
          scrollWidth = _this$view3.scrollWidth,
          clientWidth = _this$view3.clientWidth;
      var trackWidth = getInnerWidth(this.trackHorizontal);
      var thumbWidth = this.getThumbHorizontalWidth();
      return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
    }
  }, {
    key: "getScrollTopForOffset",
    value: function getScrollTopForOffset(offset) {
      var _this$view4 = this.view,
          scrollHeight = _this$view4.scrollHeight,
          clientHeight = _this$view4.clientHeight;
      var trackHeight = getInnerHeight(this.trackVertical);
      var thumbHeight = this.getThumbVerticalHeight();
      return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
    }
  }, {
    key: "scrollLeft",
    value: function scrollLeft() {
      var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!this.view) return;
      this.view.scrollLeft = left;
    }
  }, {
    key: "scrollTop",
    value: function scrollTop() {
      var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!this.view) return;
      this.view.scrollTop = top;
    }
  }, {
    key: "scrollToLeft",
    value: function scrollToLeft() {
      if (!this.view) return;
      this.view.scrollLeft = 0;
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      if (!this.view) return;
      this.view.scrollTop = 0;
    }
  }, {
    key: "scrollToRight",
    value: function scrollToRight() {
      if (!this.view) return;
      this.view.scrollLeft = this.view.scrollWidth;
    }
  }, {
    key: "scrollToBottom",
    value: function scrollToBottom() {
      if (!this.view) return;
      this.view.scrollTop = this.view.scrollHeight;
    }
  }, {
    key: "addListeners",
    value: function addListeners() {
      /* istanbul ignore if */
      if (typeof document === 'undefined' || !this.view) return;
      var view = this.view,
          trackHorizontal = this.trackHorizontal,
          trackVertical = this.trackVertical,
          thumbHorizontal = this.thumbHorizontal,
          thumbVertical = this.thumbVertical;
      view.addEventListener('scroll', this.handleScroll);
      trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
      trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
      trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
      trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
      trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
      trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
      thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
      thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
      typeof window !== 'undefined' && window.addEventListener('resize', this.handleWindowResize);
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      /* istanbul ignore if */
      if (typeof document === 'undefined' || !this.view) return;
      var view = this.view,
          trackHorizontal = this.trackHorizontal,
          trackVertical = this.trackVertical,
          thumbHorizontal = this.thumbHorizontal,
          thumbVertical = this.thumbVertical;
      view.removeEventListener('scroll', this.handleScroll);
      trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
      trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
      trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
      trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
      trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
      trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
      thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
      thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
      typeof window !== 'undefined' && window.removeEventListener('resize', this.handleWindowResize); // Possibly setup by `handleDragStart`

      this.teardownDragging();
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(event) {
      var _this2 = this;

      var _this$props3 = this.props,
          onScroll = _this$props3.onScroll,
          onScrollFrame = _this$props3.onScrollFrame;
      if (onScroll) onScroll(event);
      this.update(function (values) {
        var scrollLeft = values.scrollLeft,
            scrollTop = values.scrollTop;
        _this2.viewScrollLeft = scrollLeft;
        _this2.viewScrollTop = scrollTop;
        if (onScrollFrame) onScrollFrame(values);
      });
      this.detectScrolling();
    }
  }, {
    key: "handleScrollStart",
    value: function handleScrollStart() {
      var onScrollStart = this.props.onScrollStart;
      if (onScrollStart) onScrollStart();
      this.handleScrollStartAutoHide();
    }
  }, {
    key: "handleScrollStartAutoHide",
    value: function handleScrollStartAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.showTracks();
    }
  }, {
    key: "handleScrollStop",
    value: function handleScrollStop() {
      var onScrollStop = this.props.onScrollStop;
      if (onScrollStop) onScrollStop();
      this.handleScrollStopAutoHide();
    }
  }, {
    key: "handleScrollStopAutoHide",
    value: function handleScrollStopAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.hideTracks();
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      this.update();
    }
  }, {
    key: "handleHorizontalTrackMouseDown",
    value: function handleHorizontalTrackMouseDown(event) {
      event.preventDefault();
      var target = event.target,
          clientX = event.clientX;

      var _target$getBoundingCl = target.getBoundingClientRect(),
          targetLeft = _target$getBoundingCl.left;

      var thumbWidth = this.getThumbHorizontalWidth();
      var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
      this.view.scrollLeft = this.getScrollLeftForOffset(offset);
    }
  }, {
    key: "handleVerticalTrackMouseDown",
    value: function handleVerticalTrackMouseDown(event) {
      event.preventDefault();
      var target = event.target,
          clientY = event.clientY;

      var _target$getBoundingCl2 = target.getBoundingClientRect(),
          targetTop = _target$getBoundingCl2.top;

      var thumbHeight = this.getThumbVerticalHeight();
      var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
      this.view.scrollTop = this.getScrollTopForOffset(offset);
    }
  }, {
    key: "handleHorizontalThumbMouseDown",
    value: function handleHorizontalThumbMouseDown(event) {
      event.preventDefault();
      this.handleDragStart(event);
      var target = event.target,
          clientX = event.clientX;
      var offsetWidth = target.offsetWidth;

      var _target$getBoundingCl3 = target.getBoundingClientRect(),
          left = _target$getBoundingCl3.left;

      this.prevPageX = offsetWidth - (clientX - left);
    }
  }, {
    key: "handleVerticalThumbMouseDown",
    value: function handleVerticalThumbMouseDown(event) {
      event.preventDefault();
      this.handleDragStart(event);
      var target = event.target,
          clientY = event.clientY;
      var offsetHeight = target.offsetHeight;

      var _target$getBoundingCl4 = target.getBoundingClientRect(),
          top = _target$getBoundingCl4.top;

      this.prevPageY = offsetHeight - (clientY - top);
    }
  }, {
    key: "setupDragging",
    value: function setupDragging() {
      css(document.body, disableSelectStyle);
      typeof document !== 'undefined' && document.addEventListener('mousemove', this.handleDrag);
      typeof document !== 'undefined' && document.addEventListener('mouseup', this.handleDragEnd);
      document.onselectstart = returnFalse;
    }
  }, {
    key: "teardownDragging",
    value: function teardownDragging() {
      css(document.body, disableSelectStyleReset);
      typeof document !== 'undefined' && document.removeEventListener('mousemove', this.handleDrag);
      typeof document !== 'undefined' && document.removeEventListener('mouseup', this.handleDragEnd);
      document.onselectstart = undefined;
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(event) {
      this.dragging = true;
      event.stopImmediatePropagation();
      this.setupDragging();
    }
  }, {
    key: "handleDrag",
    value: function handleDrag(event) {
      if (this.prevPageX) {
        var clientX = event.clientX;

        var _this$trackHorizontal = this.trackHorizontal.getBoundingClientRect(),
            trackLeft = _this$trackHorizontal.left;

        var thumbWidth = this.getThumbHorizontalWidth();
        var clickPosition = thumbWidth - this.prevPageX;
        var offset = -trackLeft + clientX - clickPosition;
        this.view.scrollLeft = this.getScrollLeftForOffset(offset);
      }

      if (this.prevPageY) {
        var clientY = event.clientY;

        var _this$trackVertical$g = this.trackVertical.getBoundingClientRect(),
            trackTop = _this$trackVertical$g.top;

        var thumbHeight = this.getThumbVerticalHeight();

        var _clickPosition = thumbHeight - this.prevPageY;

        var _offset = -trackTop + clientY - _clickPosition;

        this.view.scrollTop = this.getScrollTopForOffset(_offset);
      }

      return false;
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd() {
      this.dragging = false;
      this.prevPageX = this.prevPageY = 0;
      this.teardownDragging();
      this.handleDragEndAutoHide();
    }
  }, {
    key: "handleDragEndAutoHide",
    value: function handleDragEndAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.hideTracks();
    }
  }, {
    key: "handleTrackMouseEnter",
    value: function handleTrackMouseEnter() {
      this.trackMouseOver = true;
      this.handleTrackMouseEnterAutoHide();
    }
  }, {
    key: "handleTrackMouseEnterAutoHide",
    value: function handleTrackMouseEnterAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.showTracks();
    }
  }, {
    key: "handleTrackMouseLeave",
    value: function handleTrackMouseLeave() {
      this.trackMouseOver = false;
      this.handleTrackMouseLeaveAutoHide();
    }
  }, {
    key: "handleTrackMouseLeaveAutoHide",
    value: function handleTrackMouseLeaveAutoHide() {
      var autoHide = this.props.autoHide;
      if (!autoHide) return;
      this.hideTracks();
    }
  }, {
    key: "showTracks",
    value: function showTracks() {
      clearTimeout(this.hideTracksTimeout);
      css(this.trackHorizontal, {
        opacity: 1
      });
      css(this.trackVertical, {
        opacity: 1
      });
    }
  }, {
    key: "hideTracks",
    value: function hideTracks() {
      var _this3 = this;

      if (this.dragging) return;
      if (this.scrolling) return;
      if (this.trackMouseOver) return;
      var autoHideTimeout = this.props.autoHideTimeout;
      clearTimeout(this.hideTracksTimeout);
      this.hideTracksTimeout = setTimeout(function () {
        css(_this3.trackHorizontal, {
          opacity: 0
        });
        css(_this3.trackVertical, {
          opacity: 0
        });
      }, autoHideTimeout);
    }
  }, {
    key: "detectScrolling",
    value: function detectScrolling() {
      var _this4 = this;

      if (this.scrolling) return;
      this.scrolling = true;
      this.handleScrollStart();
      this.detectScrollingInterval = setInterval(function () {
        if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
          clearInterval(_this4.detectScrollingInterval);
          _this4.scrolling = false;

          _this4.handleScrollStop();
        }

        _this4.lastViewScrollLeft = _this4.viewScrollLeft;
        _this4.lastViewScrollTop = _this4.viewScrollTop;
      }, 100);
    }
  }, {
    key: "raf",
    value: function raf(callback) {
      var _this5 = this;

      if (this.requestFrame) _raf.cancel(this.requestFrame);
      this.requestFrame = _raf(function () {
        _this5.requestFrame = undefined;
        callback();
      });
    }
  }, {
    key: "update",
    value: function update(callback) {
      var _this6 = this;

      this.raf(function () {
        return _this6._update(callback);
      });
    }
  }, {
    key: "_update",
    value: function _update(callback) {
      var _this$props4 = this.props,
          onUpdate = _this$props4.onUpdate,
          hideTracksWhenNotNeeded = _this$props4.hideTracksWhenNotNeeded;
      var values = this.getValues();

      if (true) {
        var scrollLeft = values.scrollLeft,
            clientWidth = values.clientWidth,
            scrollWidth = values.scrollWidth;
        var trackHorizontalWidth = getInnerWidth(this.trackHorizontal);
        var thumbHorizontalWidth = this.getThumbHorizontalWidth();
        var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
        var thumbHorizontalStyle = {
          width: thumbHorizontalWidth,
          transform: "translateX(".concat(thumbHorizontalX, "px)")
        };
        var scrollTop = values.scrollTop,
            clientHeight = values.clientHeight,
            scrollHeight = values.scrollHeight;
        var trackVerticalHeight = getInnerHeight(this.trackVertical);
        var thumbVerticalHeight = this.getThumbVerticalHeight();
        var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
        var thumbVerticalStyle = {
          height: thumbVerticalHeight,
          transform: "translateY(".concat(thumbVerticalY, "px)")
        };

        if (hideTracksWhenNotNeeded) {
          var trackHorizontalStyle = {
            visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
          };
          var trackVerticalStyle = {
            visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
          };
          css(this.trackHorizontal, trackHorizontalStyle);
          css(this.trackVertical, trackVerticalStyle);
        }

        css(this.thumbHorizontal, thumbHorizontalStyle);
        css(this.thumbVertical, thumbVerticalStyle);
      }

      if (onUpdate) onUpdate(values);
      if (typeof callback !== 'function') return;
      callback(values);
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var scrollbarWidth = 15;
      /* eslint-disable no-unused-vars */

      var _this$props5 = this.props,
          onScroll = _this$props5.onScroll,
          onScrollFrame = _this$props5.onScrollFrame,
          onScrollStart = _this$props5.onScrollStart,
          onScrollStop = _this$props5.onScrollStop,
          onUpdate = _this$props5.onUpdate,
          renderView = _this$props5.renderView,
          renderTrackHorizontal = _this$props5.renderTrackHorizontal,
          renderTrackVertical = _this$props5.renderTrackVertical,
          renderThumbHorizontal = _this$props5.renderThumbHorizontal,
          renderThumbVertical = _this$props5.renderThumbVertical,
          tagName = _this$props5.tagName,
          hideTracksWhenNotNeeded = _this$props5.hideTracksWhenNotNeeded,
          autoHide = _this$props5.autoHide,
          autoHideTimeout = _this$props5.autoHideTimeout,
          autoHideDuration = _this$props5.autoHideDuration,
          thumbSize = _this$props5.thumbSize,
          thumbMinSize = _this$props5.thumbMinSize,
          universal = _this$props5.universal,
          autoHeight = _this$props5.autoHeight,
          autoHeightMin = _this$props5.autoHeightMin,
          autoHeightMax = _this$props5.autoHeightMax,
          style = _this$props5.style,
          children = _this$props5.children,
          scrollbarId = _this$props5.scrollbarId,
          props = _objectWithoutProperties(_this$props5, _excluded);
      /* eslint-enable no-unused-vars */


      var didMountUniversal = this.state.didMountUniversal;

      var containerStyle = _objectSpread(_objectSpread(_objectSpread({}, containerStyleDefault), autoHeight && _objectSpread(_objectSpread({}, containerStyleAutoHeight), {}, {
        minHeight: autoHeightMin,
        maxHeight: autoHeightMax
      })), style);

      var viewStyle = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, viewStyleDefault), {}, {
        // Hide scrollbars by setting a negative margin
        marginRight: scrollbarWidth ? -scrollbarWidth : 0,
        marginBottom: scrollbarWidth ? -scrollbarWidth : 0
      }, autoHeight && _objectSpread(_objectSpread({}, viewStyleAutoHeight), {}, {
        // Add scrollbarWidth to autoHeight in order to compensate negative margins
        minHeight: isString(autoHeightMin) ? "calc(".concat(autoHeightMin, " + ").concat(scrollbarWidth, "px)") : autoHeightMin + scrollbarWidth,
        maxHeight: isString(autoHeightMax) ? "calc(".concat(autoHeightMax, " + ").concat(scrollbarWidth, "px)") : autoHeightMax + scrollbarWidth
      })), autoHeight && universal && !didMountUniversal && {
        minHeight: autoHeightMin,
        maxHeight: autoHeightMax
      }), universal && !didMountUniversal && viewStyleUniversalInitial);

      var trackAutoHeightStyle = {
        transition: "opacity ".concat(autoHideDuration, "ms"),
        opacity: 0
      };

      var trackHorizontalStyle = _objectSpread(_objectSpread(_objectSpread({}, trackHorizontalStyleDefault), autoHide && trackAutoHeightStyle), (!scrollbarWidth || universal && !didMountUniversal) && {
        display: 'none'
      });

      var trackVerticalStyle = _objectSpread(_objectSpread(_objectSpread({}, trackVerticalStyleDefault), autoHide && trackAutoHeightStyle), (!scrollbarWidth || universal && !didMountUniversal) && {
        display: 'none'
      });

      return /*#__PURE__*/createElement(tagName, _objectSpread(_objectSpread({}, props), {}, {
        style: containerStyle,
        ref: function ref(_ref2) {
          _this7.container = _ref2;
        }
      }), [/*#__PURE__*/cloneElement(renderView({
        style: viewStyle
      }), {
        key: 'view',
        ref: function ref(_ref3) {
          _this7.view = _ref3;
        }
      }, children), /*#__PURE__*/cloneElement(renderTrackHorizontal({
        style: trackHorizontalStyle
      }), {
        key: 'trackHorizontal',
        ref: function ref(_ref4) {
          _this7.trackHorizontal = _ref4;
        }
      }, /*#__PURE__*/cloneElement(renderThumbHorizontal({
        style: thumbHorizontalStyleDefault
      }), {
        ref: function ref(_ref5) {
          _this7.thumbHorizontal = _ref5;
        }
      })), /*#__PURE__*/cloneElement(renderTrackVertical({
        style: trackVerticalStyle
      }), {
        key: 'trackVertical',
        ref: function ref(_ref6) {
          _this7.trackVertical = _ref6;
        }
      }, /*#__PURE__*/cloneElement(renderThumbVertical({
        style: thumbVerticalStyleDefault
      }), {
        ref: function ref(_ref7) {
          _this7.thumbVertical = _ref7;
        }
      }))]);
    }
  }]);

  return Scrollbars;
}(Component);

Scrollbars.propTypes = {
  onScroll: PropTypes.func,
  onScrollFrame: PropTypes.func,
  onScrollStart: PropTypes.func,
  onScrollStop: PropTypes.func,
  onUpdate: PropTypes.func,
  renderView: PropTypes.func,
  renderTrackHorizontal: PropTypes.func,
  renderTrackVertical: PropTypes.func,
  renderThumbHorizontal: PropTypes.func,
  renderThumbVertical: PropTypes.func,
  tagName: PropTypes.string,
  thumbSize: PropTypes.number,
  thumbMinSize: PropTypes.number,
  hideTracksWhenNotNeeded: PropTypes.bool,
  autoHide: PropTypes.bool,
  autoHideTimeout: PropTypes.number,
  autoHideDuration: PropTypes.number,
  autoHeight: PropTypes.bool,
  autoHeightMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  autoHeightMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  universal: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node
};
Scrollbars.defaultProps = {
  renderView: renderViewDefault,
  renderTrackHorizontal: renderTrackHorizontalDefault,
  renderTrackVertical: renderTrackVerticalDefault,
  renderThumbHorizontal: renderThumbHorizontalDefault,
  renderThumbVertical: renderThumbVerticalDefault,
  tagName: 'div',
  thumbMinSize: 30,
  hideTracksWhenNotNeeded: false,
  autoHide: false,
  autoHideTimeout: 1000,
  autoHideDuration: 200,
  autoHeight: false,
  autoHeightMin: 0,
  autoHeightMax: 200,
  universal: false
};
export default Scrollbars;